// Copyright ©️ 2026 eVolve MEP, LLC

import type { WorkOrder } from '@evolvemep/api-ts';
import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';
import { useHasAccess } from 'hooks/user/useHasAccess';
import { FabItemsGroupBySelect } from 'modules/Shop/EvolveFabrication/FabItemsGroupBySelect';
import { FabricationItems } from 'modules/Shop/EvolveFabrication/FabricationItems';

type Props = {
  workOrder: WorkOrder;
  onElementsUpdated: () => void;
};

export const FabricationItemsModal = ({ workOrder, onElementsUpdated }: Props) => {
  const hasFabricationAccess = useHasAccess('fabrication', 'read');
  const [opened, { open, close }] = useDisclosure(false);

  if (!hasFabricationAccess) return null;

  return (
    <>
      <Button size="xs" variant="light" onClick={open}>
        View fab items
      </Button>
      <WrappedModal
        miniHeader={workOrder.identifier}
        title={workOrder.name}
        subtitle="Fabrication items"
        headerRightComponent={<FabItemsGroupBySelect facilityId={workOrder.facilityId} />}
        opened={opened}
        hideModalButtons
        size="xxl"
        tall
        onClose={close}
      >
        <FabricationItems
          onElementsUpdated={onElementsUpdated}
          workOrderPageOpts={{
            workOrder,
            hideHeader: true,
          }}
        />
      </WrappedModal>
    </>
  );
};
